import * as angular from 'angular';
import { upgradeExternalNg1Dependency } from '../common/ng1-upgrade-factory';

export const $translateToken = upgradeExternalNg1Dependency<angular.translate.ITranslateService>('$translate');
